export const baseFormColumn = (ctx) => {
  return [
    {
      prop: 'contractNo',
      name: '合同号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractStatus',
      name: '合同状态',
      type: 'select',
      disabled: true,
      options: ctx.contractStatusList,
      placeholder: '自动生成',
    },
    {
      prop: 'parkCompanyName',
      name: '园区公司',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'parkDepartmentName',
      name: '业务部门',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
      placeholder: '自动填充',
    },
    {
      prop: 'contractType',
      name: '合同类型',
      type: 'input',
      // options: ctx.contractTypeList,
      disabled: true,
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
    },
    {
      prop: 'signDate',
      name: '签约日期',
      type: 'date',
    },
    {
      prop: 'signPlace',
      name: '签约地点',
      type: 'input',
    },
    {
      prop: 'signPerson',
      name: '签约人',
      type: 'input',
    },
    {
      prop: 'leaseArea',
      name: '租赁面积',
      type: 'inputNumber',
    },
    {
      prop: 'leaseDateFrom',
      name: '租赁日期从',
      type: 'startDaterangePicker',
    },
    {
      prop: 'leaseDateUnit',
      name: '租赁日期至',
      type: 'endDaterangePicker',
    },
    {
      prop: 'leaseTerm',
      name: '租赁期限',
      type: 'input',
    },
    {
      prop: 'storageName',
      name: '仓库名称',
      type: 'input',
    },
    {
      prop: 'storageAddress',
      name: '仓库地址',
      type: 'input',
    },
    {
      prop: 'paymentMethod',
      name: '付款方式',
      type: 'select',
      options: ctx.contractPayMethodList,
    },
    {
      prop: 'partnerName',
      name: '合作伙伴名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
      },
      currentValue: ctx.baseFormData.partnerName,
      disabled: ctx.disabledList.includes('partnerName'),
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'partnerCode',
      name: '合作伙伴编码',
      type: 'input',
      disabled: true,
      placeholder: '自动带出',
    },
    // {
    //   name: '开户行',
    //   prop: 'depositBank',
    //   type: 'searchTableSpec',
    //   searchType: 'bank',
    //   currentValue: ctx.baseFormData.depositBank,
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    // },
    // {
    //   prop: 'bankAccount',
    //   name: '银行账号',
    //   type: 'input',
    //   disabled: true,
    //   placeholder: '自动带出',
    // },
    {
      name: '违约利率',
      prop: 'absentInterestRate',
      type: 'inputNumber',
    },
    {
      prop: 'paperContractNo',
      name: '纸质合同号',
      type: 'input',
    },
    {
      prop: 'contractAmount',
      name: '合同金额',
      type: 'input',
    },
    {
      prop: 'superviseContractNo',
      name: '关联合同号',
      type: 'input',
      isHidden: ctx.$route.query.status != 'renew' && ctx.$route.query.status != 'detail',
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'input',
    },
  ];
};

// 表单校验
export const baseFormRules = (ctx) => {
  return {
    contractName: [{ required: true, message: '合同名称必填', trigger: 'blur' }],
    leaseArea: [{ required: true, message: '租赁面积必填', trigger: ['change', 'blur'] }],
    leaseDateFrom: [
      { required: true, message: '租赁日期从必填', trigger: ['change', 'blur'] },
      { validator: validatorLeaseDateFrom(ctx), trigger: ['blur', 'change'] },
    ],
    leaseDateUnit: [
      { required: true, message: '租赁日期至必填', trigger: ['change', 'blur'] },
      { validator: validatorLeaseDateUnit(ctx), trigger: ['blur', 'change'] },
    ],
    paymentMethod: [{ required: true, message: '付款方式必填', trigger: ['change', 'blur'] }],
    contractAmount: [{ required: true, message: '合同金额必填', trigger: ['change', 'blur'] }],
  };
};

const validatorLeaseDateFrom = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseFormData.leaseDateFrom && value > ctx.baseFormData.leaseDateUnit) {
        callback(new Error('租赁日期必须小于租赁日期至!'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};
const validatorLeaseDateUnit = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseFormData.leaseDateUnit && value < ctx.baseFormData.leaseDateFrom) {
        callback(new Error('租赁日期至必须大于租赁日期从!'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};
